export default "__VITE_ASSET__DmVOJmP9__"